import { render, staticRenderFns } from "./RecognitionVoiceService.vue?vue&type=template&id=830e923c&scoped=true"
import script from "./RecognitionVoiceService.vue?vue&type=script&lang=js"
export * from "./RecognitionVoiceService.vue?vue&type=script&lang=js"
import style0 from "./RecognitionVoiceService.vue?vue&type=style&index=0&id=830e923c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830e923c",
  null
  
)

export default component.exports